module.exports = __webpack_public_path__ + "img/290.7bedc339.png";